'use strict';
import config from './config';
import logger from './logger';

function init() {
	setKeyValue('templateName', config.dataLayer.page.templateName);
	setKeyValue('isAffiliate', config.dataLayer.isAffiliate.toString());
	window.admiral('targeting', 'ready'); // Allows admiral to make it's targeting calls now that we have set our targeting
}

function setKeyValue(key, value) {
	if (!key) {
		logger.warn('Admiral: Failed to set value - key not set.');
		return;
	}

	if (window.admiral === undefined) {
		logger.warn('Admiral: Failed to set value - admiral was undefined.');
		return;
	}

	window.admiral('targeting', 'set', key, value);
	logger.info(`Admiral: Set value {${key}, ${value}}`);
}

export default {
	init
};
